import React from 'react';
import PropTypes from 'prop-types';
import Button from 'Components/Button';
import styles from './styles.scss';
import Typography from 'Components/Typography';

export default class JobListItem extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    introtext: PropTypes.string.isRequired,
    date: PropTypes.string,
    location: PropTypes.string,
    category: PropTypes.string,
    ctaHref: PropTypes.string.isRequired,
  };

  render() {
    const { title, introtext, date, location, category, ctaHref } = this.props;

    return (
      <div className={styles.joblistitem}>
        <div className={styles.head}>
          <Typography.Headline
            level="h3"
            value={title}
            forceUppercase={true}
            additionalAriaLabelText={[
              date ? `Starttermin: ${date}` : undefined,
              location ? `Standort: ${location}` : undefined,
              category ? `Bereich: ${category}` : undefined,
            ]
              .filter((item) => item !== undefined)
              .join(', ')}
          />
          <ul className={styles.shortfacts} aria-hidden="true">
            {date && <li>{date}</li>}
            {location && <li>{location}</li>}
            {category && <li>{category}</li>}
          </ul>
        </div>
        <div className={styles.content}>
          <p className={styles.introtext}>{introtext}</p>
          <span className={styles.secondary}>
            <Button
              label="Details"
              variant="secondary"
              href={ctaHref}
              small
              screenReaderLabel={`Erfahre mehr über ${title}`}
            />
          </span>
          <span className={styles.primary}>
            <Button
              label="Details"
              variant="primary"
              href={ctaHref}
              small
              screenReaderLabel={`Erfahre mehr über ${title}`}
            />
          </span>
        </div>
      </div>
    );
  }
}
